// services/fetchRegister.js
import { USERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchRegister = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(USERS.users, method, body);

  if (response.code === 201) {
    // ✅ Registro exitoso
    return response;
  } else if (response.code === 400) {
    throw new Error("Datos inválidos para registrar");
  } else if (response.code === 409) {
    throw new Error("El correo ya está registrado");
  } else {
    throw new Error("Error al registrar usuario");
  }
};
